import React from 'react'
import { FormattedMessage } from '@dragonraider5/react-intl'
import { getExceptionMessage } from '../../../utils/exceptions'
import ExceptionMessage from '../../../components/ExceptionMessage'

function ApplicationsError({ error }) {
  return (
    <ExceptionMessage
      message={<FormattedMessage {...getExceptionMessage(error)} />}
    />
  )
}

export default ApplicationsError
